import { AuthenticationActions } from './actions'
import { AuthenticationGetters } from './getters'
import { AuthenticationMutations } from './mutations'
import { AuthenticationState } from './state'

export const AUTHENTICATION_NAMESPACE = 'authentication'

export const Authentication = {
  namespaced: true,
  state: AuthenticationState,
  actions: AuthenticationActions,
  mutations: AuthenticationMutations,
  getters: AuthenticationGetters,
}
